import React from 'react';
import CreateCollection from '../actions/CreateCollection';

const CollectionMessage = ({data, onAction}) => {
  const {title, success_message, listings} = data;

  const handleCreateCollection = async () => {
    // Add user action message
    onAction({
      type: 'user',
      text: 'Create collection from suggestions',
    });

    // Call create collection
    const result = await CreateCollection(data);

    // Add response message
    onAction({
      type: result.success ? 'assistant' : 'error',
      text: result.success
        ? 'Collection created successfully!'
        : 'Failed to create collection. Please try again.',
    });
  };

  return (
    <div className="bg-white rounded-lg border border-gray-200">
      <div className="p-4">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
          <p className="text-sm text-gray-500 mt-1">{success_message}</p>
        </div>

        {/* Main Products Section */}
        {/* Dynamic Report Table */}
        <div className="overflow-auto">
          <table className="min-w-full border-collapse">
            <thead>
              <tr className="border-b border-gray-100 bg-gray-50">
                {listings.length > 0 &&
                  Object.keys(listings[0]).map(key => (
                    <th
                      key={key}
                      className="text-left py-2 px-2 text-xs font-medium text-gray-500 whitespace-nowrap">
                      {key}
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {listings.map((row, index) => (
                <tr
                  key={index}
                  className={index % 2 === 0 ? 'bg-gray-50/50' : 'bg-white'}>
                  {Object.values(row).map((value, idx) => (
                    <td
                      key={idx}
                      className="py-3 px-2 text-sm text-gray-700 whitespace-nowrap">
                      {value}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Action Buttons */}
        <div className="flex  justify-end gap-2">
          <button
            onClick={handleCreateCollection}
            className="px-4 py-2 bg-primary text-white rounded-lg 
                           text-sm font-medium hover:bg-indigo-700 
                           transition-colors">
            Create Collection
          </button>
          {/* <button
            className="px-4 py-2 bg-white text-gray-700 rounded-lg 
                           text-sm font-medium border border-gray-200
                           hover:bg-gray-50 transition-colors">
            Customize
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default CollectionMessage;
